import '../../../resources/css/admin_style.css';
import { IAM_SERVER_UNIFIEDID, IAM_SERVER_UNIFIEDPROFILE } from '../../../utils/Config';
import { DialogEnum, showDialog } from '../../../utils/dialog/Dialog';
import styles from './component.module.css';
import axios from "../../../utils/api/axios";
import { useEffect, useState } from 'react';
import { getCookie } from '../../../utils/cookies/cookies';

/**
 * 연락처 판넬
 * @param callback
 * @param delay
 */
function ContactInfoPanel({ user , onUserUpdate }) {
  const [Isidentityfier, setIsIdentityfier] = useState(false);

  const fetchLinkedAccounts = async () => {
    try {
      const resUnifiedProfile = await axios.get(`${IAM_SERVER_UNIFIEDPROFILE}/get/${user?.email}`);
      const resUnifiedId = await axios.get(`${IAM_SERVER_UNIFIEDID}/get/${resUnifiedProfile.data.data.unifiedId}`);

      const authInfo =  resUnifiedId.data.data.authInfo ?? {};

      let hasVerifiedPhone = false; // 검증된 폰 정보가 있는지 여부를 추적하는 플래그

      // authInfo 객체의 모든 날짜 키를 순회합니다.
      for (const dateKey in authInfo) {
          if (Object.prototype.hasOwnProperty.call(authInfo, dateKey)) {
              const dateSpecificInfo = authInfo[dateKey];

              // 해당 날짜에 'phone' 배열이 있고, 배열이 비어있지 않다면
              if (dateSpecificInfo.phone && Array.isArray(dateSpecificInfo.phone) && dateSpecificInfo.phone.length > 0) {
                  // 'phone' 배열의 각 항목을 순회합니다.
                  for (const phoneEntry of dateSpecificInfo.phone) {
                      // verification_status가 "verified"인지 확인합니다.
                      if (phoneEntry.verification_status === "verified") {
                          hasVerifiedPhone = true; // 검증된 폰 정보를 찾았음
                          break; // 더 이상 찾을 필요가 없으므로 내부 루프 중단
                      }
                  }
              }
          }
          if (hasVerifiedPhone) {
              break; // 검증된 폰 정보를 찾았으므로 외부 루프도 중단
          }
      }

      setIsIdentityfier(hasVerifiedPhone); // 최종 결과에 따라 상태 업데이트

    } catch (e) {
    }
  };

  useEffect(() => {
    fetchLinkedAccounts();
  }, []);

  const handlePhoneVerify = () => {
    window.requestConnetxa.requestIndentifier()
      .then((identifier) => {
        if (identifier === "cancel") {
          showDialog(DialogEnum.DEFAULT, "취소", "사용자가 본인인증을 취소하였습니다.");
        } else if (identifier === "fail") {
          showDialog(DialogEnum.FAIL, "실패", "본인인증 실패: 다시 시도해 주세요.");
        } else {
          let verifiedCustomer = identifier.verifiedCustomer;

          // 본인인증이 완료 된 후 사용자 전화 번호 업데이트 및 사용자 인증수단 업데이트 
          // 이미 본인인증된 계정이 있는경우 확인 피룡
					
					const now = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
					let unifiedId = {};  
					//unifiedId 에서 인증 정보에 중복 인증 확인
					let authInfo = {};
					authInfo[now] = {
					  phone: [
						  {
							  value: verifiedCustomer.phoneNumber,
							  verification_status: "verified",
							  authentication_provider: "KG 이니시스",
							  ci: verifiedCustomer.ci || ""
							}
						]
          };
					    
					unifiedId = {
					 	authInfo :authInfo
					};
					   
          window.requestConnetxa.existUnifiedId(unifiedId)
            	.then(data => {
						      if (data && data.data) {
                    showDialog(DialogEnum.DEFAULT, "알림", "이미 본인인증이 완료된 계정이 있습니다.");
						      } else {
                    // { label: "남성", value: "man" }, "MALE"
                    // { label: "여성", value: "woman" } "FEMALE"

                    const userId = getCookie("user_id");

                    const params = {
                      unifiedProfileId: userId,
                      contactInfo: verifiedCustomer.phoneNumber, // ✅ key 수정
                      birth: verifiedCustomer.birthDate,
                      name: verifiedCustomer.name,
                      gender: verifiedCustomer.gender === 'MALE' ? 'man' : 'woman',
                    };

                    const url = IAM_SERVER_UNIFIEDPROFILE + "/update";
                    axios.post(url, params)
                      .then((res) => {

                        const unifiedId = res.data.data.unifiedId;
                        const unifiedParams = {
                          unifiedId: unifiedId,
                          authInfo :authInfo
                        };

                        const unifiedUrl = IAM_SERVER_UNIFIEDID + "/update";

                        axios.post(unifiedUrl, unifiedParams)
                          .then((res) => {
                            showDialog(DialogEnum.DEFAULT, "성공", "사용자 인증 완료");

                            if (typeof onUserUpdate === "function") {
                              onUserUpdate(true);
                            }
                          })
                          .catch((e) => {
                            showDialog(DialogEnum.DEFAULT, "실패", e.response?.data?.resultMessage || "오류 발생");
                          });
                      })
                      .catch((e) => {
                        showDialog(DialogEnum.DEFAULT, "실패", e.response?.data?.resultMessage || "오류 발생");
                      });
						      }
						    })
						    .catch(err => {
						      console.error("본인확인 오류", err);
						      alert("본인확인 오류가 발생했습니다.");
						    });

          // TODO: identifier 정보를 서버에 저장 등 처리
        }
      })
      .catch((err) => {
        console.error("❌ 인증 실패:", err);
        alert("❌ 본인인증 중 오류가 발생했습니다.");
      });
  };

  return (
    <div className={styles.infoCard}>
      <h2 className={styles.infoTitle}>연락처 정보</h2>
      <div className={styles.profileList}>
          {/* 이메일 */}
          <div className={styles.infoItem}>
                  <span className={styles.infoItemLabel}>이메일</span>
                  <span className={`${styles.infoItemValue} ${styles.noArrow}`}>
                    {user?.email || "설정되지 않음"}
                  </span>
                </div>

                {/* 휴대전화 */}
                <div
                  className={styles.infoItem}
                  onClick={!Isidentityfier ? handlePhoneVerify : undefined}
                  style={{ cursor: !Isidentityfier ? "pointer" : "default" }}
                >
                  <span className={styles.infoItemLabel}>휴대전화</span>
                  <span className={styles.infoItemValue}>
                    {Isidentityfier  ? (
                      user.phone_number
                    ) : (
                      <>
                        본인인증 하기 <span className={styles.editArrow}>&gt;</span>
                      </>
                    )}
                  </span>
                </div>
      </div>
      
    </div>
  );
}

export default ContactInfoPanel;